import React from 'react';
import { Link } from 'react-router-dom';
import { openCalendlyPopup } from '../utils/calendly';
import { useLanguage } from '../contexts/LanguageContext';
import { LanguageSwitcher } from './LanguageSwitcher';
export function Navigation() {
  const {
    t
  } = useLanguage();
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0a0e1a]/95 backdrop-blur-sm border-b border-white/5" data-id="element-217">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-218">
        <div className="flex items-center justify-between h-16 lg:h-20" data-id="element-219">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2" data-id="element-220">
            <span className="text-xl font-bold text-white" data-id="element-221">CRM</span>
            <span className="text-xl font-bold text-[#ff6b35]" data-id="element-222">Kraft</span>
          </Link>

          {/* Right side: Language Switcher + CTA */}
          <div className="flex items-center gap-4" data-id="element-223">
            <LanguageSwitcher data-id="element-224" />
            <button onClick={openCalendlyPopup} className="bg-[#ff6b35] hover:bg-[#ff5722] text-white px-5 py-2.5 rounded-lg text-sm font-semibold transition-colors" data-id="element-225">
              {t('nav.demo')}
            </button>
          </div>
        </div>
      </div>
    </nav>;
}